import React from 'react';
import Icon from './Icon';
import {separateurNumber} from '../../libs/helper';

const Answers = (props) => {

    return (
        <div className="answers-count"><Icon type="chat-o"/>{separateurNumber(props.count.comment || props.value || 0)}</div>
    )
};

Answers.defaultProps = {
    count: {
        like: 0,
        view: 0,
        comment: 0
    }
};

export default Answers;
